const ACTION_TITLES = {
  any: {
    id: 0,
    text: "any"
  },
  view: {
    id: 1,
    text: "View",
	i18_text: 'view',
	icon: "fa-light fa-glasses-round"
  },
  quickView: {
    id: 2,
    text: "Quick View",
	i18_text: 'quick_view',
	icon: "fa-light fa-glasses-round"
  },
  webView: {
    id: 3,
    text: "Web View",
	i18_text: '',
	icon: "fa-light fa-glasses-round"
  },
  view2: {
    id: 4,
    text: "View 2",
	i18_text: '',
	icon: "fa-light fa-glasses-round"
  },
  hisView: {
    id: 5,
    text: "HIS View",
	i18_text: '',
	icon: ""
  },
  newQuickView: {
    id: 6,
    text: "New Quick View",
	i18_text: 'quick_view',
	icon: "fa-light fa-glasses-round"
  },
  newAdvancedView: {
    id: 7,
    text: "New Advanced View",
	i18_text: 'advance_view',
	icon: "fa-light fa-binoculars"
  },
  writeToCD: {
    id: 11,
    text: "Write to CD",
	i18_text: 'write_to_cd',
	icon: "fa-light fa-compact-disc"
  },
  copyToFlash: {
    id: 12,
    text: "Copy to Flash",
	i18_text: '',
	icon: ""
  },
  print: {
    id: 21,
    text: "Print",
	i18_text: '',
	icon: ""
  },
  paperPrint: {
    id: 22,
    text: "Paper Print",
	i18_text: 'print_report',
	icon: "fa-light fa-print"
  },
  forward: {
    id: 31,
    text: "Forward",
	i18_text: '',
	icon: ""
  },
  delete: {
    id: 41,
    text: "Delete",
	i18_text: '',
	icon: ""
  },
  modify: {
    id: 51,
    text: "Modify",
	i18_text: '',
	icon: ""
  },
  AdmitInHIS: {
    id: 61,
    text: "Admit in HIS",
	i18_text: '',
	icon: ""
  },
  sendToHIS: {
    id: 62,
    text: "Send to HIS",
	i18_text: 'send_to_his',
	icon: ""
  },
  SendToPatient: {
    id: 63,
    text: "Send to Patient",
	i18_text: 'send_to_patient',
	icon: "fa-light fa-comment-sms"
  }
};

export const getFullName = (id) => {
	let value = ACTION_TITLES[findKeyByID(id)]
	return value.text
}

export const getI18Name = (id) => {
	let value = ACTION_TITLES[findKeyByID(id)]
	return value.i18_text
}

export const getIcon = (id, className, title) => {
	let value = ACTION_TITLES[findKeyByID(id)]
	return iconTag(value?.icon, className, title)
}

const findKeyByID = (id) => {
	return Object.entries(ACTION_TITLES).find(([, value]) => value.id.toString() === id.toString())?.[0]
}
const iconTag = (icon, className='', title='') => {
	return <i className={`${icon} ${className}`} title={title}/>
}

export default ACTION_TITLES;